import { defineStore } from "pinia";
import { useStatisticFiltersStore } from "./statisticFilters";

// Store do obsługi stanu procesu generowania statystyk (krok po kroku w wizardzie/statystykach)
export const useStatisticStore = defineStore({
  id: "statistic",
  state: () => ({
    step: 1,        // Aktualny krok w procesie/statystykach (np. wybór filtrów, potwierdzenie itd.)
    isResult: false // Czy jesteśmy już na etapie pokazywania wyników/statystyk
  }),
  actions: {
    // Ustawia ręcznie flagę isResult (czy pokazywać wyniki)
    setResultState(value) {
      this.isResult = value;
    },
    // Przejście do następnego kroku procesu
    nextStep() {
      const filtersStore = useStatisticFiltersStore();
      if (this.step === 1) {
        // Walidacja podstawowych wymaganych danych na pierwszym kroku
        filtersStore.checkRequireData1(true);
        if (filtersStore.error) {
          // Jeśli błąd, zostajemy na pierwszym kroku, nie przechodzimy dalej
          this.step = 1;
          this.isResult = false;
        } else {
          // Przechodzimy do następnego kroku
          this.step++
        }
      } else if (this.step < 4) {
        // Każdy inny krok niż ostatni – zwiększamy numer kroku
        this.step++;
      }
      if (this.step === 4) {
        // Ostatni krok – pełna walidacja wszystkich wymaganych danych
        filtersStore.checkRequireData();
        if (filtersStore.error) {
          // Jeśli błąd – reset procesu do początku
          this.step = 1;
          this.isResult = false;
        } else {
          // Jeśli OK, wyświetlamy wynik, resetujemy krok (by można zacząć jeszcze raz)
          this.isResult = true;
          this.step = 1;
        }
      }
      return this.step;
    },
    // Powrót do poprzedniego kroku
    previousStep() {
      if (this.step > 1) {
        this.step--;
      }
      return this.step;
    },
    // Całkowity reset procesu generowania statystyk
    clear() {
      this.step = 1;
      this.isResult = false;
    },
  },
});

// Obsługa Hot Module Reload dla Pinia (ułatwia dev/zmiany w kodzie bez reloadu całej strony)
// if (typeof import.meta !== 'undefined' && import.meta.hot) {
//   import.meta.hot.accept(acceptHMRUpdate(useStatisticStore, import.meta.hot));
// }
